$(function(){
    updateSwiper();
})

$(window).resize(function(){
    updateSwiper();
})

function updateSwiper(){

    $(".custom-list-swiper").each(function(){
      if($(window).width() < 750){
        $(this).attr("slides-per-view", $(this).attr("data-mob"));
      }
      else{
        $(this).attr("slides-per-view", $(this).attr("data-desk"));
      }
    })
    if($(window).width() < 990){
        $(".custom-feed-swiper").attr("slides-per-view", 3);
    }
    else{
        $(".custom-feed-swiper").attr("slides-per-view", 6);
    }

    if($(window).width() < 750){
      $(".custom-logos-slider-swiper").attr("slides-per-view", 3);
      
      $(".custom-card-swiper").attr("slides-per-view", 1.2);
      $(".custom-card-swiper").attr("loop", "true");
      $(".custom-card-swiper").attr("centered-slides", "true");

      $(".custom-testimonial-2-swiper").attr("slides-per-view", 1.1);
      $(".custom-testimonial-2-swiper").attr("space-between", 10);

      $(".custom-main-product-media-thumb-swiper").attr("slides-per-view", 5);
      if($(".custom-main-product-media-swiper").hasClass("custom-main-product--show-dots")){
        $(".custom-main-product-media-swiper").attr("pagination", "true");
        $(".custom-main-product-media-swiper").attr("pagination-clickable", "true");
      }
    }
    else{
      $(".custom-logos-slider-swiper").attr("slides-per-view", 4);

      $(".custom-card-swiper").attr("slides-per-view", 3);
      $(".custom-card-swiper").removeAttr("loop");
      $(".custom-card-swiper").removeAttr("centered-slides");

      $(".custom-testimonial-2-swiper").attr("slides-per-view", 3);
      $(".custom-testimonial-2-swiper").attr("space-between", 40);

      $(".custom-main-product-media-thumb-swiper").attr("slides-per-view", 7.5);
      if($(".custom-main-product-media-swiper").hasClass("custom-main-product--show-dots")){
        $(".custom-main-product-media-swiper").removeAttr("pagination", "true");
        $(".custom-main-product-media-swiper").removeAttr("pagination-clickable", "true");
      }
    }

    if($(window).width() <= 550){
        $(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("1280")
    }
    else if($(window).width() <= 749){
        $(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("1024")
    }
    else if($(window).width() <= 989){
        $(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("989")
    }
    else if($(window).width() <= 1024){
        $(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("749")
    }
    else if($(window).width() <= 1280){
        $(".custom-reviews-swiper").attr("slides-per-view", 3);
        console.log("550")
    }
    else{
        $(".custom-reviews-swiper").attr("slides-per-view", 4);
        console.log("else")
    }
}

$(".custom-faq-block-title").click(function(){
    if($(this).parent().hasClass("active")){
        $(this).parent().toggleClass("active");
        $(this).next(".custom-faq-block-content").slideToggle(250);
    }
    else{
        $(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block").removeClass("active");
        $(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block-content").slideUp(250);
        $(this).parent().addClass("active");
        $(this).next(".custom-faq-block-content").slideDown(250);
    }
})

$(".custom-acc-title-wrapper").on("click", function(e){
  e.preventDefault();
  e.stopPropagation();

  var content = $(this).next(".custom-acc-content");

  if($(this).hasClass("active")){
      $(this).removeClass("active");
      content.stop(true, true).slideUp(250);
  } else {
      $(this).addClass("active");
      content.stop(true, true).slideDown(250);
  }
});

$(".footer-block__heading").click(function(){
    if($(this).hasClass("active")){
        $(this).toggleClass("active");
        $(this).next(".footer-block__details-content").slideToggle(250);
    }
    else{
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__heading").removeClass("active");
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__details-content").slideUp(250);
        $(this).addClass("active");
        $(this).next(".footer-block__details-content").slideDown(250);
    }
});

$(document).on("click", ".custom-cart-upsell-atc", function(){
    let arr = [];
    arr.push({
      'id': $(this).attr("data-id"),
      'quantity': 1,
      'properties': {
        '_emf_cart_special_offer': 'true',
        '_emf_cart_special_discount': '10'
      }
    });
    AddUpsellToCart(arr, $(this));
})

$(".custom-hotspots-item").click(function(){
  $(this).parent().find(".custom-hotspots-item").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".custom-hotspots").find(".custom-hotspots-mobile-text").text($(this).find(".custom-hotspots-text").text());
})

$(document).on("click", ".custom-addon-atc", function(){
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, $(this), true);
})

function AddUpsellToCart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        $("cart-drawer.drawer").removeClass("is-empty");
        $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
        $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          $(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

  $(document).on("click", ".custom-header-drawer-close", function(){
    $(".header__icon--menu").trigger("click");
  })
  
  Fancybox.bind("[data-fancybox]", {});

  $(".custom-main-product-swatch").hover(function(){
    $(".custom-product-swatch-heading span").text($(this).attr("data-title"));
  }, function(){
    $(".custom-product-swatch-heading span").text($(this).attr("data-d-title"));
  })






document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".custom-hero-rating-wrapper");

  if (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      const scrollToReviews = () => {
        const target = document.querySelector(".jdgm-carousel-wrapper");

        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        } else {
          // retry until app loads
          setTimeout(scrollToReviews, 300);
        }
      };

      scrollToReviews();
    });
  }
});

/* EMF Klaviyo Viewed Product asset fallback 2026-05-19 start */
(function() {
  if (window.__emfKlaviyoViewedProductAssetFallback) return;
  window.__emfKlaviyoViewedProductAssetFallback = true;

  function readMetaProduct() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var product = meta && meta.product;
    if (!product || !product.id || !Array.isArray(product.variants) || !product.variants.length) return null;

    var selectedVariantId = meta.selectedVariantId;
    var variant = product.variants.find(function(item) {
      return String(item.id) === String(selectedVariantId);
    }) || product.variants[0];

    var canonical = document.querySelector('link[rel="canonical"]');
    var title = document.querySelector('meta[property="og:title"]');
    var image = document.querySelector('meta[property="og:image"]');
    var price = document.querySelector('meta[property="product:price:amount"], meta[property="og:price:amount"]');
    var productName = (variant && variant.name) || (title && title.content) || document.title;
    var priceValue = variant && typeof variant.price === "number" ? variant.price / 100 : Number(price && price.content) || null;

    return {
      ProductName: productName,
      ProductID: product.id,
      SKU: variant && variant.sku || null,
      Categories: product.type ? [product.type] : [],
      ImageURL: image && image.content ? image.content.replace(/^http:/, "https:") : null,
      URL: canonical && canonical.href || window.location.href,
      Brand: product.vendor || null,
      Price: priceValue,
      VariantID: variant && variant.id || null,
      VariantName: variant && (variant.public_title || variant.name) || null,
      Title: productName,
      ItemId: product.id,
      ImageUrl: image && image.content ? image.content.replace(/^http:/, "https:") : null,
      Url: canonical && canonical.href || window.location.href,
      Metadata: {
        Brand: product.vendor || null,
        Price: priceValue,
        VariantID: variant && variant.id || null,
        VariantName: variant && (variant.public_title || variant.name) || null
      }
    };
  }

  function send(attempt) {
    var item = readMetaProduct();
    if (!item) return;

    var bucket = Math.floor(Date.now() / 1800000);
    var storageKey = "emf_klaviyo_viewed_product_asset_" + item.ProductID + "_" + item.VariantID + "_" + bucket;
    try {
      if (window.sessionStorage && sessionStorage.getItem(storageKey)) return;
      if (window.sessionStorage) sessionStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {}

    if (window._learnq && typeof window._learnq.push === "function") {
      window._learnq.push(["track", "Viewed Product", item]);
      return;
    }

    if (window.klaviyo && typeof window.klaviyo.track === "function") {
      window.klaviyo.track("Viewed Product", item);
      return;
    }

    if (attempt < 30) window.setTimeout(function() { send(attempt + 1); }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { window.setTimeout(function() { send(0); }, 300); });
  } else {
    window.setTimeout(function() { send(0); }, 300);
  }
})();
/* EMF Klaviyo Viewed Product asset fallback 2026-05-19 end */

/* EMF SPF Tube After Sun accordion client patch 2026-05-23 start */
(function() {
  function setAccordion(title, html) {
    var accordions = document.querySelectorAll('.custom-acc');
    for (var i = 0; i < accordions.length; i += 1) {
      var titleEl = accordions[i].querySelector('.custom-acc-title span');
      var contentEl = accordions[i].querySelector('.custom-acc-content');
      if (titleEl && contentEl && titleEl.textContent.trim() === title) {
        contentEl.innerHTML = html;
      }
    }
  }

  function patchSpfAfterSunKit() {
    if (window.location.pathname !== '/products/spf-tube-after-sun-kit') return;
    setAccordion('How to use', '<p><strong>Step 1: Use SPF before and during outdoor time.</strong><br>Apply the SPF 30 Mineral Sunscreen Tube generously to exposed skin before you head outside. Use enough to cover face, ears, neck, shoulders, arms, and any other exposed areas. Reapply at least every two hours, and after swimming, sweating, or towel-drying. Follow the Drug Facts directions and warnings on the package.</p><p><strong>Step 2: Use After Sun after the towels, shower, or lake-day reset.</strong><br>Apply Aloe + Cucumber After Sun Balm to clean, dry skin after outdoor time. Scoop a small amount from the tin, warm it between your fingertips, then smooth over areas that feel dry or tight. Reapply as needed throughout the day or evening. A little goes a long way.</p>');
    setAccordion('Ingredients', '<p><strong>SPF 30 Mineral Sunscreen Tube</strong></p><p><strong>Active Ingredient:</strong> Non-Nano Zinc Oxide.</p><p><strong>Inactive Ingredients:</strong> Grass-Fed Beef Tallow, Fractionated Coconut Oil, Jojoba Oil, Sea Buckthorn Oil, Shea Butter, Cocoa Butter, Cacao Powder, Arrowroot Powder, Beeswax, Cetyl Alcohol, Tocopherol (Vitamin E) Oil, Vanilla Oleoresin.</p><p><strong>Aloe + Cucumber After Sun Balm</strong></p><p>Grass-Fed Beef Tallow, Shea Butter, Cocoa Butter, Arrowroot Powder, Aloe Oil, Jojoba Oil, Sea Buckthorn Oil, Tocopherol (Vitamin E) Oil, Coconut Oil, Cucumber Oil, Cetyl Alcohol, Beeswax, Vanilla Oleoresin.</p>');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchSpfAfterSunKit);
  } else {
    patchSpfAfterSunKit();
  }
})();
/* EMF SPF Tube After Sun accordion client patch 2026-05-23 end */

/* EMF_SPF_AFTER_SUN_DUO_REAL_PACKAGING_HOTFIX_2026_05_27 */
(function () {
  var productPath = '/products/beef-tallow-sunscreen-and-after-sun-duo-spf-30';
  var oldFile = 'before-after-sun-duo-spf-30-sunscreen-tube-after-sun-repair-balm-grass-fed-tallow-non-nano-zinc-reef-safe';
  var beachBase = '//eatmyface.co/cdn/shop/files/spf-duo-hero-beach-couple-real-products-2026-05-26';
  var beachVersion = '1779845827';
  var towelBase = '//eatmyface.co/cdn/shop/files/spf-after-sun-duo-real-packaging-towel-lifestyle-2026-05-27';
  var towelVersion = '1779844505';
  var beachAlt = 'Beef tallow SPF 30 sunscreen tube and After Sun Repair tin held by a couple on a golden-hour beach, grass-fed tallow with non-nano zinc oxide, reef-safe sun-care duo by Eat My Face';
  var towelAlt = 'Eat My Face SPF 30 sunscreen tube and After Sun Repair balm in a towel lifestyle scene with real package artwork';

  function sizedUrl(base, version, ext, sourceValue) {
    var size = '';
    var match = String(sourceValue || '').match(/_(\d+x)\.png/i);
    if (match) size = '_' + match[1];
    return base + size + '.' + ext + '?v=' + version;
  }

  function replaceStaleDuoImages() {
    if (window.location.pathname !== productPath) return;

    document.querySelectorAll('a[href*="' + oldFile + '"], img[src*="' + oldFile + '"]').forEach(function (node) {
      var attr = node.tagName === 'A' ? 'href' : 'src';
      var value = node.getAttribute(attr) || '';
      var useTowel = node.classList.contains('custom-iwvt-img') || Boolean(node.closest('[id*="custom_img_video_text_Agzbhg"]'));
      var next = useTowel ? sizedUrl(towelBase, towelVersion, 'jpg', value) : sizedUrl(beachBase, beachVersion, 'png', value);
      node.setAttribute(attr, next);
      if (node.tagName === 'IMG') node.setAttribute('alt', useTowel ? towelAlt : beachAlt);
      if (node.tagName === 'A') node.setAttribute('data-alt', useTowel ? towelAlt : beachAlt);
    });

    document.querySelectorAll('meta[property="og:image"], meta[property="og:image:secure_url"], meta[name="twitter:image"]').forEach(function (node) {
      var content = node.getAttribute('content') || '';
      if (content.indexOf(oldFile) !== -1) node.setAttribute('content', 'https://eatmyface.co/cdn/shop/files/spf-duo-hero-beach-couple-real-products-2026-05-26.png?v=' + beachVersion);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceStaleDuoImages);
  } else {
    replaceStaleDuoImages();
  }
  window.addEventListener('pageshow', replaceStaleDuoImages);
})();

